import { guideSteps } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="选片指南"
          title="第一次来？四步就能找到今晚想看的片"
          desc="本站不提供播放，而是把分散的片单信息整理到一起。按照下面四步走，通常一到两分钟就能锁定目标，不熟悉流程也能直接上手。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          {guideSteps.map((item) => (
            <div key={item.id} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-100 font-heading text-lg font-bold text-accent-800">
                {item.step}
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div className="rounded-lg bg-primary-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-file-list-3-line text-xl" aria-hidden="true"></i>
            </span>
            <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">
              <a href="#today" className="transition-colors hover:text-primary-700">
                先看更新节奏
              </a>
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
              明确哪些内容今天就能看到，避免看完介绍却暂时无法观看。
            </p>
          </div>
          <div className="rounded-lg bg-secondary-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
              <i className="ri-scales-3-line text-xl" aria-hidden="true"></i>
            </span>
            <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">
              <a href="#ranking" className="transition-colors hover:text-secondary-700">
                对比热度与评分
              </a>
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
              热门不一定高分，两个榜单交叉查看，更容易找到适合自己口味的片。
            </p>
          </div>
          <div className="rounded-lg bg-accent-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-accent-950">
              <i className="ri-window-2-line text-xl" aria-hidden="true"></i>
            </span>
            <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">
              <a href="#genres" className="transition-colors hover:text-accent-800">
                用类型快速收窄
              </a>
            </h4>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
              先锁定类型再挑具体影片，比漫无目的地翻列表更省时间。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}